// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import Vuex from 'vuex'
import store from './vuex/store';
import App from './App'
import router from './router'
import Axios from 'axios'
import 'lib-flexible'
import Global from '@/components/global'
import wx from 'weixin-js-sdk'
// import uweb from 'vue-uweb'

Vue.use(Vuex);
// Vue.use(uweb, '1273096345');
Vue.use(VueClipboard);
Vue.config.productionTip = false;
Vue.prototype.$http = Axios;
Vue.prototype.GLOBAL = Global;//全局变量
Vue.prototype.$http.defaults.headers.common['App-Common-Params'] = '{"package_name": "h5_hzqg"}';
Vue.prototype.setCookie = (c_name, value, expiredays) => {

    // if(c_name == 'token'){
    //     alert('c_name:'+c_name);
    // }

    var date = new Date();
    date.setTime(date.getTime() + expiredays);
    var expires = "; expires=" + date.toGMTString();
    var path = ";path=/";
    var domain = ";domain=.huazhen2008.com";
    // var domain = ";domain=172.16.1.224";

    if (window.location.hostname != 'localhost') {
        document.cookie = c_name + "=" + value + expires + domain + path;
    }
    else {
        document.cookie = c_name + "=" + value + expires  + path;
    }

}

function setCookie(c_name, value, expiredays) {
    var date = new Date();
    date.setTime(date.getTime() + expiredays);
    var expires = "; expires=" + date.toGMTString();
    var path = "; path=/";
    // var domain = ";domain=.172.16.1.224"
    var domain = ";domain=.huazhen2008.com"

    if (window.location.hostname != 'localhost') {
        document.cookie = c_name + "=" + value + expires + domain + path;
    }
    else {
        document.cookie = c_name + "=" + value + expires  + path;
    }
}

function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return (arr[2]);
    else
        return '';
}

function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

function goAppLogin(type){
    saveBackPage();
    var para_url = '/pages/loginFive/loginFive';
    if(type){
        para_url += "?type=" + type;
    }
    wx.miniProgram.navigateTo({url:para_url});
}

function saveBackPage(){
    setCookie('backPage', window.location.href, 1000 * 60 * 60 * 24 * 2);
}

function clearCookie(name) {
    setCookie(name, "", -1);
}

function getRequest() {
    var url = location.search; //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}

Vue.prototype.getCookie = getCookie;
Vue.prototype.delCookie = delCookie;
Vue.prototype.clearCookie = clearCookie;
Vue.prototype.goAppLogin = goAppLogin;
Vue.prototype.getRequest = getRequest;
Vue.prototype.saveBackPage = saveBackPage;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js